import { FC, ReactNode } from 'react'
import { FormAnswerAvatar, FormAnswerAvatarType } from './Avatar'

const FormAnswer: FC & FormAnswerAvatarType = (): ReactNode => <></>

FormAnswer.Avatar = FormAnswerAvatar

export default FormAnswer
